module.exports = __webpack_public_path__ + "img/18.c563180f.jpg";